import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';
import { infrastructureItemToJsonQueryFieldMap } from '../../../packages/JsonQuery/constants/infrastructureFieldMap';
import { EInfrastructureItem } from '../../../packages/api-models/common/json_query';

const ALL_ITEMS = Object.keys(infrastructureItemToJsonQueryFieldMap).map(Number) as EInfrastructureItem[];

export const selectInfrastructure = createSelector(selectJsonQuery, jsonQuery => {
  const selected = ALL_ITEMS.filter(item =>
    Boolean(getTermValue(infrastructureItemToJsonQueryFieldMap[item])(jsonQuery)),
  );

  return selected.length > 0 ? selected : null;
});
